import * as React from 'react'
import styled from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'

import { COLORS, styles as S } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import { useNavigation } from '../../../../hooks/useNavigation'
import { PATHS } from '../../../../paths'

type PushRewardsMobileProps = {}

const Heading = styled.div`
  margin-bottom: 30px;

  ${S.heading.M} {
    margin-bottom: 13px;
  }
`

const Content = styled.div`
  text-align: center;

  ${S.button.CallToAction} {
    margin-bottom: 15px;
  }
`

const Wrapper = styled.div`
  background-color: ${COLORS.PRIMARY_SAND_100};
  padding: 25px 10px;
  margin-bottom: 25px;
`

export function PushRewardsMobile(): React.ReactElement<PushRewardsMobileProps> {
  const navigation = useNavigation()
  return (
    <Wrapper>
      <Heading>
        <S.heading.M>{t('Rewards')}</S.heading.M>
        <S.copy.M.light>{t('Back project and receive exclusive rewards.')}</S.copy.M.light>
      </Heading>
      <Content>
        <S.button.CallToAction as={RouterLink} kind="secondary" to={navigation.pathTo(PATHS.REWARDS)}>
          {t('See rewards')}
        </S.button.CallToAction>
        <S.copy.S.regular>{t('Or continue reading')}</S.copy.S.regular>
      </Content>
    </Wrapper>
  )
}
